function injectStyle (ssrContext) {
  require("!!../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?minimize!../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-ef53ef00\",\"scoped\":true,\"hasInlineConfig\":true}!stylus-loader!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Addmenu.vue")
}
var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Addmenu.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-ef53ef00\",\"hasScoped\":true,\"preserveWhitespace\":false}!../../../../../node_modules/vue-loader/lib/template-compiler/preprocessor?engine=pug!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Addmenu.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ef53ef00",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/parts/header/addmenu/Addmenu.vue
// module id = 76ee4fab35b1d4a072b6
// module chunks = 8